import React from 'react';
import './App.css';
import AppRoute from './AppRoute'
import AppNav from './AppNav'

function App() {
  return (
    <div className="App">
      <AppRoute />
      <AppNav />
    </div>
  );
}

export default App;
